import styled from 'styled-components';
import { rgba } from 'polished';

import { useOptionTableSettings } from '#/features/options/option-tables-context';
import { cFFFFFF } from '#/colors';
import { BaseCell, BaseRow, BaseRowGroup } from './atoms';

export default function HeaderRow() {
  const optionTableSettings = useOptionTableSettings();

  return (
    <Row>
      <RowGroup>
        {optionTableSettings.columns.map(
          (column) =>
            column.visible && <Cell key={column.key}>{column.header}</Cell>,
        )}
      </RowGroup>

      <Cell css="justify-self: center;">Strike</Cell>

      <RowGroup>
        {optionTableSettings.columns.map(
          (column) =>
            column.visible && <Cell key={column.key}>{column.header}</Cell>,
        )}
      </RowGroup>
    </Row>
  );
}

const Row = styled(BaseRow)``;

const RowGroup = styled(BaseRowGroup)``;

const Cell = styled(BaseCell)`
  font-size: 12px;
  font-weight: 500;
  color: ${rgba(cFFFFFF, 0.5)};
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: ${rgba(cFFFFFF, 0.25)};
`;
